import type { AdminResetPasswordResponse } from '@/types/api.types'

/** Copy shown before an admin sends a password reset. */
export function adminPasswordResetConfirmMessage(name: string): string {
  return `Email "${name}" a one-time link to set a new password? They will be signed out of every session now. Their current password is not changed; the link works once and expires in 24 hours. If they have not accepted their invitation yet, the invitation is sent again instead.`
}

/** The toast after an admin reset, by what was sent and whether email went out. */
export function adminPasswordResetOutcome(result: AdminResetPasswordResponse): {
  level: 'success' | 'warning'
  message: string
} {
  if (result.delivery === 'invite') {
    return result.emailDispatched
      ? { level: 'success', message: 'Invitation sent again' }
      : {
          level: 'warning',
          message: 'Invitation renewed, but email sending is not available right now.',
        }
  }
  return result.emailDispatched
    ? { level: 'success', message: 'Password reset link sent. They have been signed out.' }
    : {
        level: 'warning',
        message:
          'They have been signed out and a reset link was created, but email sending is not available right now.',
      }
}
